import { OnInit, OnDestroy, Directive } from '@angular/core';
import { ErrorResponse } from '@core/models/response-models/response-models';
import { MasterDataService } from '@core/services/master-data.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { filter } from 'rxjs/operators';
import {
  AuthActionCodes,
  EntityCodes,
} from '@core/models/global-entities/global-enums';
import { AuthorizationService } from '@core/services/authorization.service';
import { PropertyBasicInfo } from '@core/models/global-entities/global-entities';
import { DialogFactoryService } from '@core/services/dialog-factory.service';
import { AlertDialogType } from '@core/utils/dialog-utils';
import { AppFeatures } from './app-settings';

@Directive()
export class BaseComponentDirective implements OnInit, OnDestroy {
  public FormErrors: Array<ErrorResponse> = [];
  public routeSubscriber: Subscription = null;
  public routerSubscriber: Subscription = null;
  public _AuthActionCodes = AuthActionCodes;
  public _AppFeatures = AppFeatures;
  public MAX_NOTES_COUNT = 4000;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public masterService: MasterDataService,
    public authorizationService: AuthorizationService,
    public dialogFactory: DialogFactoryService
  ) {
    if (this.route && this.route.data) {
      this.routeSubscriber = this.route.data.subscribe((data) => {
        this.masterService.ActiveParentRoute = data.ActiveParentRoute;
      });

      this.routerSubscriber = this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe((a: NavigationEnd) => {
          const url = a.url.split('?')[0];
          this.masterService.ActiveUrl = url;
          console.log(url);
        });
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.routerSubscriber) {
      this.routerSubscriber.unsubscribe();
    }
  }

  ClearErrors() {
    this.FormErrors = [];
  }

  AlertFailure(message = 'ERR_SERVER_UNKNOWN_ERR') {
    let dialogRef = this.dialogFactory.openAlert({
      title: 'TITLE.TITLE_ALERT_FAILURE',
      type: AlertDialogType.Error,
      subTitle: 'TS.TS_REQUEST_FAILURE',
      message: message,
      okText: 'BTN.BTN_DISMISS',
    });
    dialogRef.afterClosed().subscribe(() => {
      dialogRef = null;
    });
  }

  AlertFailures(FormErrors?: Array<ErrorResponse>) {
    let dialogRef = this.dialogFactory.openAlert({
      title: 'TITLE.TITLE_ALERT_FAILURE',
      type: AlertDialogType.Error,
      subTitle: 'TS.TS_REQUEST_FAILURE',
      message: FormErrors[0].ErrorMessage.toString(),
      okText: 'BTN.BTN_DISMISS',
    });

    dialogRef.afterClosed().subscribe(() => {
      dialogRef = null;
    });
  }

  AlertSuccess(message: string, data?: any) {
    let dialogRef = this.dialogFactory.openAlert({
      title: 'TITLE.TITLE_ALERT_SUCCESS',
      type: AlertDialogType.Success,
      subTitle: 'TS.TS_UPDATE_SUCCESS',
      message: message,
      okText: 'BTN.BTN_OK',
    });
    dialogRef.afterClosed().subscribe(() => {
      dialogRef = null;
    });
  }

  generateArray(length: number) {
    return new Array(length);
  }

  formatDate(date) {
    return date
      ? DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)
      : null;
  }

  CheckAuth_Action(Action: string): boolean {
    return this.authorizationService.CheckAuth_Action(Action);
  }

  CheckAuth_Property_Action(PropertyId: number, Action: string): boolean {
    return this.authorizationService.CheckAuth_Property_Action(
      PropertyId,
      Action
    );
  }

  CheckAuth_ActionList(actionList: AuthActionCodes[]): boolean {
    return this.authorizationService.CheckAuth_ActionList(actionList);
  }

  CheckAuth_EntityCode(entityCode: EntityCodes): boolean {
    return this.authorizationService.CheckAuth_EntityCode(entityCode);
  }

  GetProperties_Action(Action: string): Array<PropertyBasicInfo> {
    return this.authorizationService.GetProperties_Action(Action);
  }

  GetPropertyDefault_Action(
    Action: string,
    ActivePropertyId: number
  ): PropertyBasicInfo | null {
    const allowed = this.GetProperties_Action(Action);
    const filtered = allowed.filter((p) => p.PropertyId === ActivePropertyId);
    if (filtered.length > 0) {
      return filtered[0];
    }
    if (allowed.length > 0) {
      return allowed[0];
    }
    // no matching property found
    return null;
  }
}
